<span [ngClass]="'display-flex flex-align-center smart-alert-type type-'+type">
  <span class="smart-alert-type-text">{{'notification.' + type + '.' + type | translate}}</span>
</span>
